import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';
import {AppService} from '../../../app.service';

@Component({
    selector: 'app-radiobutton',
    templateUrl: './radio-button.component.html',
    styleUrls: ['./radio-button.scss']
})
export class RadioButtonComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;

    constructor(public appService: AppService) {
    }

    ngOnInit() {
    }
}
